import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
import { Button } from './ui/Button';
export function Pricing() {
  return <section id="pricing" className="py-24 bg-base" data-id="element-186">
      <div className="container mx-auto px-4" data-id="element-187">
        <div className="text-center mb-16" data-id="element-188">
          <h2 className="md:text-5xl font-extrabold text-forest-dark mb-4 text-[28px]" data-id="element-189">
            🛒 ELEGÍ TU MEGAPACK
          </h2>
          <p className="text-muted text-[16px]" data-id="element-190">
            Dos opciones · Mismo acceso inmediato
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto items-center" data-id="element-191">
          {/* Standard Tier */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl p-8 shadow-lg border border-sand flex flex-col h-full" data-id="element-192">
            <div className="mb-6" data-id="element-193">
              <p className="text-muted font-bold mb-2" data-id="element-194">OPCIÓN 1</p>
              <h3 className="text-2xl font-bold text-forest-dark mb-2 flex items-center gap-2" data-id="element-195">
                ⛏️ MEGAPACK MINERÍA LISTO™
              </h3>
              <p className="text-forest font-bold" data-id="element-196">6 Tomos + 5 Bonos</p>
            </div>

            <div className="mb-8" data-id="element-197">
              <p className="text-muted/70 line-through text-lg mb-1" data-id="element-198">
                $65.000 ARS
              </p>
              <div className="flex items-end gap-2" data-id="element-199">
                <span className="text-5xl font-black text-forest-dark" data-id="element-200">
                  $19.990
                </span>
                <span className="text-xl font-bold text-muted mb-1" data-id="element-201">ARS</span>
              </div>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-202">
              {['TOMO 1: Fundamentos de la Minería', 'TOMO 2: Geología Aplicada a la Minería', 'TOMO 3: Explotación Minera', 'TOMO 4: Procesamiento de Minerales', 'TOMO 5: Seguridad, Ambiente y Legislación Minera', 'TOMO 6: Innovación y Gestión Minera 2026', 'BONO 1: Banco de 100 Actividades para Docentes', 'BONO 2: Banco Completo de Evaluaciones (167 instrumentos)', 'BONO 3: Planificaciones Docentes Anuales y Trimestrales', 'BONO 4: Recursos Didácticos: Infografías, Fichas y Mapas', 'BONO 5: 20 Proyectos y Talleres Prácticos Completos', 'Acceso de por vida', 'Actualizaciones gratuitas'].map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-203">
                  <Check className="w-5 h-5 text-forest shrink-0 mt-0.5" data-id="element-204" />
                  <span className="text-forest-dark" data-id="element-205">{feature}</span>
                </li>)}
            </ul>

            <a href="https://emprendepackcentral.store/cart/48309209628866:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-206">
              <Button variant="secondary" size="lg" fullWidth withArrow data-id="element-207">
                QUIERO MI MEGAPACK AHORA
              </Button>
            </a>
          </motion.div>

          {/* Pro Tier */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-white rounded-3xl p-8 shadow-2xl border-2 border-gold flex flex-col h-full relative lg:scale-105 z-10" data-id="element-208">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-gold text-white px-4 py-1.5 rounded-full font-bold text-sm flex items-center gap-1.5 whitespace-nowrap shadow-lg" data-id="element-209">
              <Star className="w-4 h-4 fill-white" data-id="element-210" /> MÁS ELEGIDO
            </div>

            <div className="mb-6 mt-2" data-id="element-211">
              <p className="text-muted font-bold mb-2" data-id="element-212">OPCIÓN 2</p>
              <h3 className="text-2xl font-bold text-forest-dark mb-2 flex items-center gap-2" data-id="element-213">
                ⛏️ MEGAPACK MINERÍA + UPSELL PREMIUM
              </h3>
              <p className="text-gold-dark font-bold" data-id="element-214">
                6 Tomos + 5 Bonos + Módulo PRO: 120 Secuencias, IA Minera y
                Proyectos ABP 2026
              </p>
            </div>

            <div className="mb-8" data-id="element-215">
              <p className="text-muted/70 line-through text-lg mb-1" data-id="element-216">
                $100.000 ARS
              </p>
              <div className="flex items-end gap-2" data-id="element-217">
                <span className="text-5xl font-black text-forest-dark" data-id="element-218">
                  $27.990
                </span>
                <span className="text-xl font-bold text-muted mb-1" data-id="element-219">ARS</span>
              </div>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-220">
              <li className="flex items-start gap-3" data-id="element-221">
                <Check className="w-5 h-5 text-gold-dark shrink-0 mt-0.5" data-id="element-222" />
                <span className="text-forest-dark font-bold" data-id="element-223">
                  Todo lo del MegaPack Minería Listo, MÁS:
                </span>
              </li>
              {['UPSELL PREMIUM: 120 Secuencias Didácticas Listas', 'UPSELL PREMIUM: 100 Situaciones Problemáticas Contextualizadas', 'UPSELL PREMIUM: 80+ Prompts de IA para la Enseñanza', 'UPSELL PREMIUM: 15 Proyectos ABP Completos', 'UPSELL PREMIUM: 25 Rúbricas Profesionales'].map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-224">
                  <Check className="w-5 h-5 text-gold-dark shrink-0 mt-0.5" data-id="element-225" />
                  <span className="text-gold-dark font-bold" data-id="element-226">{feature}</span>
                </li>)}
            </ul>

            <a href="https://emprendepackcentral.store/cart/48309462565058:1" target="_blank" rel="noopener noreferrer" className="block" data-id="element-227">
              <Button variant="primary" size="lg" fullWidth withArrow className="text-lg" data-id="element-228">
                ⚡ QUIERO EL MEGAPACK + UPSELL PREMIUM
              </Button>
            </a>

            <p className="text-center text-xs text-muted mt-4" data-id="element-229">
              Podés pagar con tarjeta de crédito o débito, transferencia
              bancaria o Mercado Pago en pesos argentinos.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}